@if (control) {
  @let title = text();
  @if (title) {
    <div #label id="{{ question.id }}-label-content" [innerHTML]="title"></div>
  }
  @if (controlHasError()) {
    <div class="alert alert-danger error pill form-error-list">
      <div id="{{ question.id }}-err" class="error-list-wrapper" [attr.aria-live]="'assertive'">
        <ul>
          @for (err of baseForm.errorMap.get(question.id!); track err) {
            <li>
              <span>{{ determineErrorMessage(err.error!, control, question) }}</span>
            </li>
          }
        </ul>
      </div>
    </div>
  }
  <!-- make sure aria attributes and other are configurable -->
  <div class="input-group">
    <input #input [attr.type]="inputType"
           [attr.name]="question.id"
           [attr.id]="question.id"
           class="form-control {{inputClass}}"
           [attr.autocomplete]="determineAutocompleteValue(question.id!)"
           [required]="question.required || false" [attr.aria-required]="question.required" [attr.aria-invalid]="controlHasError()"
           [attr.min]="question.min" [attr.max]="question.max"
           [formControl]="control | asFormControl"
           (blur)="revalidateInput()"
           [attr.aria-labelledby]="getAriaLabels('label')"
           [attr.aria-label]="getLabel()"
           [ngClass]="{ 'is-invalid': controlHasError()  }"/>
    <span class="input-group-text">%</span>
  </div>
  @if (!!control.validator && (control.touched || baseForm.isSubmitted())) {
    <div #feedback class="feedback-icon" aria-hidden="true">
      <i class="fa" aria-hidden="true"
         [ngClass]="{ 'fa-check-circle' : !controlHasError(), 'fa-times-circle' : controlHasError() }"></i>
    </div>
  }
  @if (standalone) {
    <div class="option-row row mx-0 mt-8">
      <div class="px-0 text-end">
        <button class="btn primary confirm-button rounded-pill"
                [disabled]="baseForm.loading || baseForm.preventSave"
                [attr.aria-label]="getLabel() + '.confirm_button'"
                (click)="onEnter($event)"
                (keydown.enter)="onEnter($event)">
          @if (baseForm.loading) {
            <span class="spinner-border spinner-border-sm mr-1"></span>
          }
          {{ messages.getText('WILL.button.save-and-continue') }}
        </button>
      </div>
    </div>
  }
}
<ng-content></ng-content>


